import * as THREE from 'three'
import { FullScreenQuad } from 'three/addons/postprocessing/Pass.js'
import WebGLContext from '../core/WebGLContext'
import vertexShader from '../shaders/quad.vert'
import noiseChunk from '../shaders/noise.glsl'

/** A full-screen quad running `fragmentShader` (with the shared noise helpers prepended). */
export function bakeQuad(fragmentShader, uniforms) {
	return new FullScreenQuad(
		new THREE.ShaderMaterial({ vertexShader, fragmentShader: noiseChunk + fragmentShader, uniforms })
	)
}

/** Render the quad once into a new mipmapped texture. */
export function bake(quad, { size = 1024, type = THREE.UnsignedByteType } = {}) {
	const { renderer } = new WebGLContext()
	const target = new THREE.WebGLRenderTarget(size, size, {
		type,
		depthBuffer: false,
		generateMipmaps: true,
		minFilter: THREE.LinearMipmapLinearFilter,
	})
	const previous = renderer.getRenderTarget()
	renderer.setRenderTarget(target)
	quad.render(renderer)
	renderer.setRenderTarget(previous)
	return target.texture
}

/** Spread the records' small integer seeds out so neighbouring records don't look alike. */
export function scrambleSeed(seed) {
	return ((seed * 0.618033988749895) % 1) * 100
}
